<template>
  <v-card>
    <v-card-text>
      <v-layout align-center>
        <v-btn v-if="backButton" icon @click="onBackButtonClicked">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-row class="ml-0">
          <v-col>
            <v-layout align-center class="height-100">
              <div>
                <h2 class="ma-0">
                  <slot name="title"></slot>
                </h2>
                <h4 class="slot font-weight-regular ma-0">
                  <slot name="subtitle"></slot>
                </h4>
              </div>
            </v-layout>
          </v-col>
          <v-col>
            <v-layout justify-end align-center style="gap: 17px; height: 100%">
              <slot name="actions"></slot>
            </v-layout>
          </v-col>
        </v-row>
      </v-layout>
    </v-card-text>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
  </v-card>
</template>

<script>
export default {
  props: {
    backButton: {
      type: Boolean,
      required: false,
      default: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  }, // props

  methods: {
    onBackButtonClicked() {
      this.$router.back();
    },
  },
};
</script>

<style>
</style>
